"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadCascader = exports.loadCascaderData = exports.loadCascaderItem = exports.cascader = void 0;
const complex_utils_1 = require("complex-utils");
const CascaderList_1 = __importDefault(require("@/class/CascaderList"));
const config_1 = require("./config");
const load_1 = __importDefault(require("./load"));
const config = {
    APPLY_KEEP_COST_Subject: 'APPLY_KEEP_COST_TYPE'
};
const configKeys = Object.keys(config);
exports.cascader = {};
const loadCascaderItem = function (key, initData) {
    return new Promise((resolve, reject) => {
        (0, config_1.loadDefaultCascaderList)(key, config[key]).then(res => {
            initData[key] = res.list;
            resolve({ status: 'success' });
        }).catch(err => {
            // eslint-disable-next-line no-console
            console.error(err);
            reject(err);
        });
    });
};
exports.loadCascaderItem = loadCascaderItem;
const loadCascaderData = function () {
    return new Promise((resolve) => {
        const initData = {};
        (0, complex_utils_1.promiseAllFinished)(configKeys.map(key => {
            return (0, exports.loadCascaderItem)(key, initData);
        })).then(() => {
            resolve({ status: 'success', data: initData });
        });
    });
};
exports.loadCascaderData = loadCascaderData;
const loadCascader = function () {
    return load_1.default.pushControl('cascader', {
        offset: 60 * 1000,
        priority: 1,
        local: 'cascader',
        check(localData) {
            if (localData) {
                const localKeys = Object.keys(localData);
                if (localKeys.length === configKeys.length) {
                    for (let i = 0; i < configKeys.length; i++) {
                        const key = configKeys[i];
                        if (localKeys.indexOf(key) === -1) {
                            return;
                        }
                    }
                    return true;
                }
            }
        },
        load() {
            return (0, exports.loadCascaderData)();
        },
        init(initData) {
            for (const key in initData) {
                exports.cascader[key] = new CascaderList_1.default({
                    name: key,
                    prop: key,
                    list: initData[key]
                });
            }
        }
    });
};
exports.loadCascader = loadCascader;
